const month = new Date().getMonth() + 1;
const year = new Date().getFullYear();

const _GetMonthsLocal = () => [
  'Ocak',
  'Şubat',
  'Mart',
  'Nisan',
  'Mayıs',
  'Haziran',
  'Temmuz',
  'Ağustos',
  'Eylül',
  'Ekim',
  'Kasım',
  'Aralık',
];

const _GetDefaultMonth = (
  type: 'last-month' | 'this-year-last-month' | 'this-month' | 'default' = 'default'
) => {
  let monthNo = 0;
  switch (type) {
    case 'last-month':
      monthNo = month === 1 ? 12 : month - 1;
      break;
    case 'this-year-last-month':
      monthNo = month === 1 ? 1 : month - 1;
      break;
    case 'this-month' || 'default':
      monthNo = month;
      break;
    default:
      monthNo = month;
      break;
  }
  return { no: monthNo, string: _GetMonthsLocal()[monthNo - 1] };
};

const _GetDefaultYear = (
  type: 'last-month' | 'this-year-last-month' | 'this-month' | 'default' = 'default'
) => {
  switch (type) {
    case 'last-month':
      return month === 1 ? year - 1 : year;
    case 'this-year-last-month' || 'this-month' || 'default':
      return year;
    default:
      return year;
  }
};

export const FormatDateTime = {
  GetMonthsLocal: _GetMonthsLocal,
  GetDefaultMonth: _GetDefaultMonth,
  GetDefaultYear: _GetDefaultYear,
};
